import { STUDIO_COMP_REF_TYPE } from '../consts';
import { isStaticPage } from '../rule-mappers/shared/helpers';
import { getCompRefType } from './get-comp-ref-type';
import { isStudioHost } from './get-editor-host';
export const getAxeBreakpointId = (a11yWizardAdapter, editorHost, metadata, compId) => {
  const axeBreakpointId = isStudioHost(editorHost) && isStaticPage(metadata.itemType) ? a11yWizardAdapter.getBreakpointIdByWidth({
    id: compId,
    type: getCompRefType(editorHost)
  }, metadata.canvasSize) : metadata.breakpointId ?? STUDIO_COMP_REF_TYPE;
  return axeBreakpointId;
};
//# sourceMappingURL=get-axe-breakpoint-id.js.map